import { updateSearch } from 'bernie-core';
import { parse } from 'query-string';
import { ActivityBannerType } from '../common/__generated__/api';
import { getIsoDateFromBexDate } from './date-helper';
import { isExperimentEnabled } from './experiment-helper';
export function getDateRange(availabilities) {
  var dateRange = null;
  if (availabilities && availabilities.length > 0) {
    dateRange = {
      startDate: getIsoDateFromBexDate(availabilities[0].date),
      endDate: getIsoDateFromBexDate(availabilities[availabilities.length - 1].date)
    };
  }
  return dateRange;
}
export function getRegionDetails(activityDetailStore, query) {
  var regionDetails = null;
  if (query && (query.location || query.rid)) {
    regionDetails = {
      location: query.location,
      rid: query.rid
    };
  } else if (activityDetailStore && activityDetailStore.activityDetail && activityDetailStore.activityDetail.location && activityDetailStore.activityDetail.location.event && activityDetailStore.activityDetail.location.event.region) {
    var locationDetails = activityDetailStore.activityDetail.location.event.region;
    regionDetails = {
      location: locationDetails.fullRegionName ? locationDetails.fullRegionName : '',
      rid: locationDetails.regionId
    };
  }
  return regionDetails;
}
export function updateBackToSearchISQuery(history, location, detailCriteriaStore) {
  if (detailCriteriaStore && !detailCriteriaStore.isQueryStringUpdated()) {
    detailCriteriaStore.setQueryStringUpdated(true);
    var queryParams = parse(location.search);
    var changedKeys = detailCriteriaStore.changedQueryKeys(queryParams, detailCriteriaStore.getActivityId());
    /**
     TODO: We should use detailQuery directly here, but it is having strange
     parameters in it on deeplink due to `detailQuery=query` in controller
     **/
    if (changedKeys && changedKeys.length > 0) {
      var detailQuery = detailCriteriaStore.detailQuery;
      var newParams = {
        location: detailQuery && detailQuery.location,
        startDate: detailQuery && detailQuery.startDate,
        endDate: detailQuery && detailQuery.endDate,
        swp: detailQuery && detailQuery.swp,
        rid: detailQuery && detailQuery.rid
      };
      updateSearch({
        history: history,
        location: location,
        newParams: newParams,
        newState: {},
        replace: true
      });
    }
  }
}
export var getStickyBarLeadPrice = function (stickyBarModel) {
  return stickyBarModel.ticket.price && stickyBarModel.ticket.price.leadAmount || 0;
};
export var trackInventoryErrorEvent = function (experimentStore, banners, analytics) {
  if (!banners || !analytics || !experimentStore) {
    return;
  }
  var nextAvailableDateBannerPresent = banners && banners.some(function (banner) {
    return banner && banner.action && banner.action.rfrr === 'LX.IS.next.available.date';
  });
  var inventoryErrorBannerPresent = banners && banners.some(function (banner) {
    return banner && banner.action === null && banner.type === ActivityBannerType.ALERT;
  });
  var nextAvailableDateEnable = isExperimentEnabled(experimentStore, 'LX_IS_Next_Available_date_PWA');
  if (nextAvailableDateEnable && !nextAvailableDateBannerPresent && inventoryErrorBannerPresent) {
    analytics.trackEvent('LX.IS.NextAvailableDate.NotFound', 'next-available-date-not-found-inventory-error', analytics.omnitureData);
  }
};